// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l0E9","placeholdersHeader":"styles_placeholdersHeader__h6zat","editorStyle":"styles_editorStyle__2KPjI","placeholdersBox":"styles_placeholdersBox__ofvEX"};